export class Canvas {

  public init() {
    if (!this.verifyCanvas()){
      this.one();
      this.two();
    }
  }

  verifyCanvas() {
    return false;
    // const canvas = document.getElementsByTagName("canvas");
    // if (canvas.length > 0) {
    //   console.log('true')
    //   return true;
    // } else {
    //   console.log('false')
    //   return false;
    // }
  }

  private one() {
  }
  private two() {
  }
}
